import React from 'react';
import event from 'event';
import styles from '../../../styles/sessions.scss';
import classNames from 'classnames';

let widthHandler = 8;

const SessionsHandler = React.createClass({
  displayName: 'Handler',

  // Mixin events
  mixins: [event],

  getInitialState: function () {
    return {
      startPosition: 0,
      isHover: false,
      isHoverLine: false,
      editing: false,
    };
  },
  getDefaultProps: function () {
    return {
      type: '',
      value: 0,
      editing: null,
      from: null,
      to: null,
    };
  },

  getPosition: function (value) {
    value -= this.props.timeFrom;
    return value * this.props.containerWidth / TIME_DAY;
  },

  onMouseDown: function (e) {
    e.preventDefault();
    this.addEvent(window, 'mousemove', this.onMouseMove);
    this.addEvent(window, 'mouseup', this.onMouseUp);

    let position = e.pageX;

    this.setState({
      editing: true,
      startPosition: position,
      startValue: this.props.from,
    });
    this.props.onEditStart(this.props.index, this.props.type);
  },

  onMouseMove: function (e) {
    let position = e.pageX,
      diffPosition = position - this.state.startPosition,
      diffValue = (diffPosition / this.props.containerWidth) * (this.props.timeFrom + TIME_DAY - this.props.timeFrom),
      newValue = Math.round(this.state.startValue + diffValue);

    this.props.onChange(this.props.index, this.props.type, newValue);
  },

  onMouseUp: function () {
    this.removeEvent(window, 'mousemove', this.onMouseMove);
    this.removeEvent(window, 'mouseup', this.onMouseUp);

    this.setState({
      editing: false,
      startPosition: 0,
      startValue: 0,
    });
    this.props.onEditStop();
  },

  onMouseEnter: function () {
    this.setState({
      isHover: true,
    });
  },
  onMouseLeave: function () {
    this.setState({
      isHover: false,
    });
  },

  onLineMouseEnter: function (e) {
    this.setState({
      isHoverLine: true,
      uiDeleteX: e.pageX,
    });
  },
  onLineMouseLeave: function (e) {
    this.setState({
      isHoverLine: false,
      uiDeleteX: 0,
    });
  },

  onDelete: function (e) {
    e.preventDefault();
    this.props.onDelete(this.props.index);
  },

  pad: function (v) {
    return (v < 10 ? '0' : '') + v;
  },

  secondsToTime: function (seconds) {
    let hour = parseInt(seconds / 60 / 60);
    let minutes = parseInt((seconds - hour * TIME_HOUR) / 60);
    return this.pad(hour) + ":" + this.pad(minutes);
  },

  render: function () {
    let line = null, uiDelete = null;

    let left = ((this.props.from - this.props.timeFrom) / TIME_DAY * 100).toFixed(2) + "%";
    let right = ((this.props.to - this.props.timeFrom) / TIME_DAY * 100).toFixed(2) + "%";
    let width = ((this.props.to - this.props.from) / TIME_DAY * 100).toFixed(2) + "%";

    if (this.state.isHoverLine && this.props.editable) {
      let uiDeleteLeft = Math.round(this.state.uiDeleteX - left - this.props.containerLeft);
      if (uiDeleteLeft > widthHandler && uiDeleteLeft < width - widthHandler) {
        uiDelete = <a href="#" style={{left: uiDeleteLeft}} onClick={this.onDelete}>x</a>;
      }
    }

    let clr = this.props.type === "Trades" ? styles["sessions-trades"] : styles["sessions-quotes"];

    line = <div className={classNames(styles["range-line"], clr)} style={{left: left, width: width}}
                onMouseEnter={this.onLineMouseEnter}
                onMouseLeave={this.onLineMouseLeave}>{uiDelete}</div>;

    let label_from = <div className={classNames(styles["sessions-label-from"], clr)}
                          style={{left: left}}>{this.secondsToTime(this.props.from - this.props.timeFrom)}</div>;
    let label_to = <div className={classNames(styles["sessions-label-to"], clr)}
                        style={{left: right}}>{this.secondsToTime(this.props.to - this.props.timeFrom)}</div>;

    return (
      <div>
        {label_from}
        {label_to}
        <div className={classNames(styles["sessions-handler"], styles["sessions-handler-from"], clr)}
             style={{left: left}}
             onMouseDown={this.props.editable && this.onMouseDown}
             onMouseEnter={this.onMouseEnter}
             onMouseLeave={this.onMouseLeave}
        ></div>
        <div className={classNames(styles["sessions-handler"], styles["sessions-handler-to"], clr)}
             style={{left: right}}
             onMouseDown={this.props.editable && this.onMouseDown}
             onMouseEnter={this.onMouseEnter}
             onMouseLeave={this.onMouseLeave}
        ></div>
        {line}
      </div>
    );
  }
});

export default SessionsHandler;



// WEBPACK FOOTER //
// ./src/js/Component/Sessions/Handler.jsx